import React from 'react'
import { storiesOf } from '@storybook/react'

import { IPlayer, Player } from 'protos'

import GameCardTeam from 'components/GameCard/components/GameCardTeam'

const defaultTeam: IPlayer[] = [
  Player.create({ playerId: 'player-0', name: 'Müller' }),
  Player.create({ playerId: 'player-1', name: 'Sigjurbjörnsson' }),
  Player.create({ playerId: 'player-2', name: 'Neuer' }),
  Player.create({ playerId: 'player-3', name: 'Boateng' }),
]

storiesOf('GameCard/GameCardTeam', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#FFF' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#FFF', width: 320, borderTop: '1px solid #EEE' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardTeam team={defaultTeam} />
  ))
